import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { TransferTicketsComponent } from 'src/app/shared/components/transfer-tickets/transfer-tickets.component';
import {
  sportInvoicesApi,
  transferTicketApi,
} from 'src/app/shared/constants/api.constants';
import { ApprovalStatusEnum } from 'src/app/shared/enums/approval-status.enum';
import { Toast } from 'src/app/shared/enums/toast';
import { HelpersService, HttpBaseService } from '@evento-ng/libs';
import { ToastService } from '@evento-ng/libs';
@Component({
  selector: 'app-sport-validate',
  templateUrl: './sport-validate.component.html',
  styleUrls: ['./sport-validate.component.scss'],
})
export class SportValidateComponent implements OnInit, OnDestroy {
  invoiceId: string;
  isValid: boolean;
  tickets: any;
  match: any;
  ticketTemplate: string;
  matchId: string;
  hours: any;
  orders: any = [];
  team: any;
  subs: Subscription[] = [];
  ApprovalStatusEnum = ApprovalStatusEnum;
  constructor(
    private route: ActivatedRoute,
    private dataService: HttpBaseService,
    public helpers: HelpersService,
    public translate: TranslateService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    this.isValid = null;
    this.validate();
  }

  validate() {
    this.route.params.subscribe((params) => {
      this.invoiceId = params.id;
      this.spinner.show();

      this.dataService
        .get(`${sportInvoicesApi}/${this.invoiceId}/validate`)
        .subscribe(
          (res) => {
            if (!res || !res.invoice) {
              console.error('Invalid response structure:', res);
              this.spinner.hide();
              return;
            }
            this.tickets = res;
            this.orders =
              res.orders?.map((item) => ({
                ...item,
                isBeingTransferred:
                  item.transferOrders?.[item.transferOrders.length - 1]
                    ?.status === 'UNDERTRANSFER',
                isTransferred:
                  item.transferOrders?.[item.transferOrders.length - 1]
                    ?.status === 'TRANSFERRED',
                transferredId:
                  item.transferOrders?.[item.transferOrders.length - 1]?.id,
              })) || [];

            const ticket = res.invoice?.ticket;
            const ticketsMatch = ticket?.ticketsMatch?.[0];
            this.matchId = ticketsMatch?.match?.id || null;
            this.match = ticketsMatch?.match || null;
            this.hours = ticketsMatch?.match?.preventQRBefore || null;
            this.team = ticket?.team || null;
            this.isValid = res.invoice.status === 'PAID';
            this.spinner.hide();
          },
          (err) => {
            console.error('API Error:', err);
            this.isValid = false;
            this.spinner.hide();
          }
        );
    });
  }

  transferInvoice(): void {
    let modalRef = this.modalService.open(TransferTicketsComponent, {
      centered: true,
    });

    modalRef.componentInstance.invoiceId = this.invoiceId;
    modalRef.componentInstance.apiCall = 'invoice';
    modalRef.componentInstance.transfer.subscribe((receivedEntry: any) => {
      this.validate();
      modalRef.dismiss();
    });
  }

  transferTicket(ticketId: string) {
    let modalRef = this.modalService.open(TransferTicketsComponent, {
      centered: true,
    });
    modalRef.componentInstance.orderId = ticketId;
    modalRef.componentInstance.apiCall = 'ticket';

    modalRef.componentInstance.transfer.subscribe((receivedEntry: any) => {
      this.validate();
      modalRef.dismiss();
    });
  }

  transferDisabledTicket(ticketId: string | number) {
    let modalRef = this.modalService.open(TransferTicketsComponent, {
      centered: true,
    });
    modalRef.componentInstance.orderId = ticketId;
    modalRef.componentInstance.apiCall = 'disabled';
    modalRef.componentInstance.transfer.subscribe((receivedEntry: any) => {
      this.validate();
      modalRef.dismiss();
    });
  }

  cancelTicket(ids) {
    this.spinner.show();
    this.dataService
      .patch(`${transferTicketApi}/cancel`, { ids: ids })
      .subscribe(
        (res) => {
          if (res.accepted != 0) {
            this.spinner.hide();
            this.toast.show(
              'Success',
              this.translate.instant('Sport.CancelTransferSuccess'),
              {
                classname: Toast.success,
              }
            );
          } else {
            this.spinner.hide();
            this.toast.show('Error', res.error.message, {
              classname: Toast.error,
            });
          }
          this.validate();
        },
        (Err) => {
          this.spinner.hide();
        }
      );
  }

  cancelInvoice() {
    let ids = this.orders.map((item) => {
      if (item.isBeingTransferred) return item.transferredId;
    });
    this.cancelTicket(ids);
  }

  allTicketsTransferred(orders: any[]) {
    let count = 0;
    for (let i = 0; i < orders.length; i++) {
      if (orders[i].isTransferred || orders[i].isBeingTransferred) {
        count++;
      }
    }
    if (count == orders.length) {
      return true;
    } else {
      return false;
    }
  }

  allTicketsUnderTransfer(orders: any[]) {
    for (let i = 0; i < orders.length; i++) {
      if (orders[i].isBeingTransferred) {
        return true;
      }
    }
    return false;
  }

  downloadInvoice(): void {
    window.open(window.origin + '/html-design/' + this.invoiceId, '_blank');
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
